import bowser from 'yola-bowser';
import view from '../../view';
import { connectedStore } from '../../store';
import contentEditable from '../../content-editable';
import selectAllTextHotkeyProcessing from '../utils/helpers/firefox-workarounds/select-all-text-hotkey-processing';

const selectionChangeHandler = (e) => {
  const store = connectedStore.get();
  const state = store.getState();
  const focusedElementId = view.selectors.getFocusedElement(state);

  // if selection will be changed by helper, don't save current selection to the store
  if (focusedElementId) {
    if (bowser.firefox && selectAllTextHotkeyProcessing(focusedElementId)) return;

    if (contentEditable.helpers.processImageSelection(focusedElementId)) return;
  }

  store.dispatch(view.actions.setSelection(e.target.defaultView.getSelection()));
};

export default selectionChangeHandler;
